import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import RequestTracking from "../requestTracking/RequestTracking";

const Home = () => {
  return (
    <div>
      <Header />
      <RequestTracking />
    </div>
  );
};

export default Home;
